(function () {
  var rootSelector = ".wd-product-drawers";

  var closePanel = function (trigger, panel) {
    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute("aria-expanded", "false");
    panel.setAttribute("hidden", "hidden");
    panel.classList.remove("is-open");
  };

  var openPanel = function (trigger, panel) {
    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute("aria-expanded", "true");
    panel.removeAttribute("hidden");
    panel.classList.add("is-open");
  };

  var init = function () {
    document.querySelectorAll(rootSelector).forEach(function (accordion) {
      if (accordion.dataset.wdDrawersBound === "true") {
        return;
      }

      accordion.dataset.wdDrawersBound = "true";

      accordion.addEventListener("click", function (event) {
        var trigger = event.target.closest("[data-wd-drawer-trigger]");

        if (!trigger || !accordion.contains(trigger) || trigger.disabled) {
          return;
        }

        event.preventDefault();

        var panelId = trigger.getAttribute("aria-controls");
        var panel = panelId ? document.getElementById(panelId) : null;

        if (!panel) {
          return;
        }

        var isOpen = trigger.getAttribute("aria-expanded") === "true";

        accordion.querySelectorAll("[data-wd-drawer-trigger]").forEach(function (otherTrigger) {
          if (otherTrigger === trigger || otherTrigger.disabled) {
            return;
          }

          var otherPanelId = otherTrigger.getAttribute("aria-controls");
          var otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
          closePanel(otherTrigger, otherPanel);
        });

        if (isOpen) {
          closePanel(trigger, panel);
        } else {
          openPanel(trigger, panel);
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
